import { useDispatch, useSelector } from 'react-redux';
import React, { FunctionComponent } from 'react';

import { DIMENSIONS } from '../../../constants';
import { selectUseMetric } from '../../../state/dexfSettings/dexfSettingsSelectors';
import { translate } from '../../../services/L10n';
import geometry from '../../../scene/util/geometry';
import swiperService from '../../../services/swiper';

import styles from '../ActionButtons.module.less';
import { selectPresentTac } from '../../../state/tac/tacReducer/tacSelectors';
import { selectIsMobile } from '../../../state/userAgent/userAgentSelectors';
import {
  selectIsMeasurementsActive,
  selectIsWallResizerActive,
} from '../../../state/scene/sceneSelectors';
import {
  actionHideMeasurements,
  actionSetWallResizerInactive,
} from '../../../state/scene';
import { t } from '../../../translations';

const WallMeasurementsLegend: FunctionComponent = () => {
  const tac = useSelector(selectPresentTac);
  const useMetricMeasures = useSelector(selectUseMetric);
  const wallResizerActive = useSelector(selectIsWallResizerActive);
  const measurementsActive = useSelector(selectIsMeasurementsActive);
  const isMobile = useSelector(selectIsMobile);

  const dispatch = useDispatch();
  const setWallResizerInactive = () =>
    dispatch(actionSetWallResizerInactive({ nonInteraction: true }));
  const hideMeasurements = () => dispatch(actionHideMeasurements({}));

  const wallSize = geometry.surround(tac.wall.points);
  const { width, height } = DIMENSIONS;

  /**
   * Renders wallmeasurements
   * @param width
   * @param height
   * @returns {JSX.Element}
   */
  const wallSizeEl = [width, height].map(dimension => (
    <span key={dimension}>
      {`${translate(t[`LABEL_${dimension.toUpperCase()}`])}
      ${swiperService.getWallMeasurementText(
        // @ts-ignore LIMITATION OF ANCIENT, PRE-HISTORIC TS-VERSION NOT SUPPORTING ENUMS
        wallSize[dimension],
        useMetricMeasures
      )}`}
    </span>
  ));

  /**
   * Handles click on wallmeasurements
   */
  const onClick = () => {
    wallResizerActive && setWallResizerInactive();
    measurementsActive && hideMeasurements();
  };

  return (
    <div className={styles.legend} onClick={onClick}>
      {isMobile && (
        <div className={styles.header}>
          {translate(t.TOOLTIP_WALL_MEASUREMENTS)}
        </div>
      )}
      {wallSizeEl}
    </div>
  );
};

export default WallMeasurementsLegend;
